import { useAppDispatch, useAppSelector } from 'hooks';
import React, { FC, useEffect, useState } from 'react';
import { ButtonType, ViewMode, UserRole } from 'types/enums';
import { facilityActions } from 'utils/store';
import styles from './styles.module.sass';
import { Button, FacilitySelector } from 'components';

type Properties = {
  onModeChange: (mode: ViewMode) => void;
  onMonitoringFacilityChange: (facilityId: string) => void;
  viewMode: ViewMode;
};

const ViewModeChanger: FC<Properties> = ({ onModeChange, onMonitoringFacilityChange, viewMode }) => {
  const dispatch = useAppDispatch();
  const { data } = useAppSelector((state) => state.user);
  const facilities = useAppSelector((state) => state.facility.facilities);
  const [isSwitcherEnable, setIsSwitcherEnable] = useState(false);
  const { adminId, caregiverId, role } = data || {};

  useEffect(() => {
    if (role === UserRole.ADMIN) {
      onModeChange(ViewMode.ADMIN);
    } else if (role === UserRole.CAREGIVER) {
      onModeChange(ViewMode.CAREGIVER);
    }
    // Note: Mode switcher is disabled for now since users have single roles
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if ((role === UserRole.ADMIN || role === UserRole.CAREGIVER) && !facilities.length) {
      dispatch(facilityActions.getAllFacilities());
    }
  }, [role, dispatch, facilities.length]);

  const isCaregiverMode = viewMode === ViewMode.CAREGIVER;
  const handleModeChange = () => {
    if (isCaregiverMode) {
      onModeChange(ViewMode.ADMIN);
    } else {
      onModeChange(ViewMode.CAREGIVER);
    }
  };

  return (
    <div className={styles.container}>
      {isSwitcherEnable && (
        <>
          <h4>Choose mode:</h4>
          <div className={styles.switcher}>
            <Button
              disabled={isCaregiverMode}
              onClick={handleModeChange}
              buttonType={isCaregiverMode ? ButtonType.PRIMARY : ButtonType.OUTLINE}
            >
              Caregiver
            </Button>
            <Button
              disabled={!isCaregiverMode}
              onClick={handleModeChange}
              buttonType={isCaregiverMode ? ButtonType.OUTLINE : ButtonType.PRIMARY}
            >
              Admin
            </Button>
          </div>
        </>
      )}
      {(role === UserRole.ADMIN || role === UserRole.CAREGIVER) && (
        <>
          <h4>Choose monitoring facility:</h4>
          <FacilitySelector onFacilityChange={onMonitoringFacilityChange} />
        </>
      )}
    </div>
  );
};

export { ViewModeChanger };
